import { useEffect, useState } from "react";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import { ActiveCredits } from "../../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/ActiveCredits";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
interface Props {
    requestBean: any;
    props: any;
}


export const HistoryCreditsAfiliates = ({ requestBean, props }: Props) => {


    useEffect(() => {
        setTaps([
            { id: 0, name: 'Historial de Creditos', disable: false },
            { id: 1, name: 'Historial de Creditos Codeudor', disable: false },
        ])
    }, [requestBean])

    const [taps, setTaps] = useState<any[]>([
        { id: 0, name: 'Historial de Creditos', disable: false },
        { id: 1, name: 'Historial de Creditos Codeudor', disable: false },
    ])

    const [indexTap, setIndexTap] = useState(0);

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h4>Deudor</h4>
                </div>
                <div className="col-md-12">
                    <ActiveCredits idAccount={props.IDAccount} />
                </div>
                <div className="col-md-12 mt-3">
                    <hr />
                    <h4>Codeudor</h4>
                </div>
                <div className="col-md-12">
                    <ActiveCredits idAccount={props.IDAccountCodeuda} />
                </div>
            </div>
        </>
    )
}